import { render } from "./index.vue?vue&type=template&id=8147d1fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8147d1fa&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8147d1fa"]])

export default __exports__